/* @flow */

import _Loading from './Loading';

export default _Loading;



// WEBPACK FOOTER //
// ./src/components/Loading/index.js